module.exports = __webpack_public_path__ + "img/arjun-kandel.19944a35.jpg";